import React from 'react';
import PropTypes from 'prop-types';
import { SmolLink } from '../SmolLink';
import { Icon } from '../../icons';
import { StyledBreadcrumbs, BreadcrumbsContainer } from './styles.js';

export const Breadcrumbs = ({ listPath }) => {
  return (
    <StyledBreadcrumbs>
      {listPath.map(({ url, title }, index) => {
        const isLastItem = index === listPath.length - 1;
        return (
          <BreadcrumbsContainer key={index}>
            <SmolLink href={url} bold={isLastItem}>
              {title}
            </SmolLink>
            {!isLastItem && (
              <Icon iconName="chevron-right" size="24px" alt={title} />
            )}
          </BreadcrumbsContainer>
        );
      })}
    </StyledBreadcrumbs>
  );
};
Breadcrumbs.displayName = 'Breadcrumbs';
Breadcrumbs.propTypes = {
  listPath: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
